import gql from "graphql-tag";

export const Staff = gql`
  query staff($agencyIds: [ID!]) {
    staff(agencyIds: $agencyIds) {
      id
      name
      operationType
      rol
      propertyTypes
      city
      number
      avatarUrl
      avatarThumbUrl
    }
  }
`;
